import React from 'react';
import Icon from '../lib/Icon';

/** Big-number stat row item. `quiet` = demoted glance strip. */
export default function Stat({ value, suffix, label, icon, tone = 'var(--ink)', trend, quiet }) {
  // Negative trends use the human (violet) family — the DS attention hue
  // (cf. PSTATUS.disabled in lib/status.js); zero renders neutral, no sign.
  const trendTone = trend > 0 ? 'var(--science-700)' : trend < 0 ? 'var(--human-700)' : 'var(--ink-muted)';
  return (
    <div style={{ padding: quiet ? '14px 20px' : '20px 22px', flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--ink-muted)', marginBottom: quiet ? 6 : 10 }}>
        <Icon name={icon} size={quiet ? 14 : 16} />
        <span className="cc-eyebrow" style={quiet ? { fontSize: 10 } : undefined}>{label}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <span style={{
          fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)',
          fontSize: quiet ? 30 : 48, lineHeight: 1, letterSpacing: 'var(--track-display)', color: tone,
        }}>{value}</span>
        {suffix && <span style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)', fontSize: quiet ? 16 : 24, color: tone }}>{suffix}</span>}
        {trend != null && (
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 3, marginLeft: 2,
            color: trendTone, fontSize: 'var(--text-sm)', fontWeight: 'var(--w-medium)',
          }}>
            {trend !== 0 && <Icon name="trendUp" size={14} style={trend < 0 ? { transform: 'scaleY(-1)' } : undefined} />}
            {trend > 0 ? `+${trend}%` : `${trend}%`}
          </span>
        )}
      </div>
    </div>
  );
}
